<script>
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrProses from "@/models/StrProses.js"; 
export default {
  mixins: [Api, Sabit, StrProses],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    formtextarea

  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    Get(){
      
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {

        
        if (this.AddEdit == "Add") { 
 
              this.Post("StrProses", this.FormData).then((res) => {
              if (res) {
                  this.$emit("TableUpdate");
                  this.$bvModal.hide("StrProses");
              }

              });
        } else {
         
         this.Update("StrProses", this.FormData).then((res) => {
              if (res) {
               
                this.$emit("TableUpdate");
                this.$bvModal.hide("StrProses");
              }
         });

        }
      }
    },
  },
};
</script>
<template>


  <Loader>

  
    <b-modal
      id="StrProses"
      size="lg"
      :title="this.AddEdit == 'Edit' ? $t('StrProses.AddEdit.FormTitleEdit')
          : $t('StrProses.AddEdit.FormTitleAdd')"
      title-class="font-18"
      hide-footer
    >


  <Form  @submit.prevent="onSubmit" > 
                       <div class="row">
                         <div class="col-md-12">
                            
                         <div class="row">
                            <div class="col-md-12">

                              <formtextarea
                                :FormDataType="FormDataType.Prosesadi"
                                :Value="FormData.Prosesadi"
                                :v="$v.FormData.Prosesadi"
                                @input="FormData.Prosesadi = $event"
                              />

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">

                              <formtextarea
                                :FormDataType="FormDataType.Prosesgirdiler"
                                :Value="FormData.Prosesgirdiler"
                                :v="$v.FormData.Prosesgirdiler"
                                @input="FormData.Prosesgirdiler = $event"
                              />

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">

                              <formtextarea
                                :FormDataType="FormDataType.Prosesciktilar"
                                :Value="FormData.Prosesciktilar"
                                :v="$v.FormData.Prosesciktilar"
                                @input="FormData.Prosesciktilar = $event"
                              />

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">

                              <formtextarea
                                :FormDataType="FormDataType.Proseskaynaklar"
                                :Value="FormData.Proseskaynaklar"
                                :v="$v.FormData.Proseskaynaklar"
                                @input="FormData.Proseskaynaklar = $event"
                              />

                            </div>
                        </div>
            

                        
                         </div>
                            </div>

                    
                            <hr>
                       
                            <button class="btn btn-primary"  type="submit" >{{ $t("StrStratejikAmac.AddEdit.Button") }}</button> 

                          </Form>                       
                       


    </b-modal>
  </Loader>
</template>
